<template>
  <button
    :id="btnAddItem"
    @click="$emit('add-order', product)"
    :disabled="isClose" v-tooltip.top="productName"
    class="group relative bg-gray-100 border border-gray-200 dark:border-gray-700 dark:bg-dark-700 shadow-sm hover:shadow-md rounded-lg overflow-hidden transition-all duration-200 flex flex-col h-42 w-full text-left active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed"
    :class="{ 'opacity-50 cursor-not-allowed': isClose }"
  >
    <!-- Image Section -->
    <div class="relative h-24 bg-gray-100 dark:bg-dark-700 w-full hidden">
      <img
        v-if="product.image"
        :src="product.image"
        :alt="productName"
        class="w-full h-full object-cover"
      />
      <div
        v-else
        class="w-full h-full flex items-center justify-center text-gray-400 dark:text-gray-600"
      >
        <PhotoIcon class="w-full h-full" />
      </div>
      <!-- Menu Type Badge -->
      <div
        class="absolute top-2 right-2 px-2 py-0.5 text-xs rounded-full capitalize bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200"
      >
        {{ product.itemCategory?.name }}
      </div>
    </div>

    <!-- Content Section -->
    <div class="flex flex-col flex-grow p-3 w-full">
      <!-- Product Code -->
      <!-- <p class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">
                {{ product.code }}
            </p> -->

      <!-- Product Name -->
      <h3
        class="font-semibold tracking-wide whitespace-pre-wrap text-gray-900 dark:text-gray-100 line-clamp-3 text-xs md:text-sm lg:text-md xl:text-lg"
      >
        {{ productName }}
      </h3>

      <!-- Price -->
      <div class="mt-auto w-full">
        <div class="flex items-center justify-between w-full">
          <p class="text-blue-600 dark:text-blue-400 font-medium" :class="{ 'line-through text-gray-500 dark:text-gray-400': product.discount_price > 0 }">
            {{ productPrice }}
          </p>
          <p v-if="product.discount_price > 0" class="text-green-600 dark:text-green-400 font-medium">
            {{ formatPrice(parseFloat(product.sale_price) - parseFloat(product.discount_price)) }}
          </p>
        </div>
        <!-- <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mt-1">
                    <span>Unit: {{ product.unit_id }}</span>
                    <span v-if="product.discount_price > 0" class="text-green-600 dark:text-green-400">
                        Disc: {{ formatPrice(product.discount_price) }}
                    </span>
                </div> -->
      </div>
    </div>
  </button>
</template>

<script>
import { PhotoIcon } from "@heroicons/vue/24/outline";

export default {
  name: "ProductCard",
  components: {
    PhotoIcon,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    productPrice: {
      type: String,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    btnAddItem: {
      type: String,
      required: true,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    },
  },
};
</script>
